import React, {Fragment} from 'react'

const FeaturesContent = [
    {
        icon: 'icon-15b',
        title: '확장 가능한 아키텍처',
        desc: '비즈니스 성장에 맞춰 유연하게 확장할 수 있는 MSA 기반 시스템 구조를 기본으로 설계합니다.',
        dataAos:'fade-up',
        dataDelay:'',
    },
    {
        icon: 'icon-16b',
        title: '투명한 개발 프로세스',
        desc: '2주 단위 스프린트와 실시간 진행 현황 공유로 고객과 함께 만들어가는 개발을 진행합니다.',
        dataAos:'fade-up',
        dataDelay:'50',
    },
    {
        icon: 'icon-17b',
        title: '납품 후 운영 지원',
        desc: '24/7 모니터링과 정기 성능 점검으로 안정적인 시스템 운영을 지속 지원합니다.',
        dataAos:'fade-up',
        dataDelay:'100',
    },
]

const FeatureThree = (props = {}) => {
    const { items } = props
    const list = items ?? FeaturesContent
    return (
        <Fragment>
            <div className="row gx-4 gx-xxl-5 justify-content-center">
                {list.map((val,i)=>(
                    <div key={i} className="col-lg-4 col-md-6" data-aos={val.dataAos} data-aos-delay={val.dataDelay}>
                        <div className="feature-style-three text-center mb-45">
                            <div className="icon"><img src={`assets/img/icon/${val.icon}.svg`} alt={`${val.title} 아이콘`}/></div>
                            <h3>
                                <a className="sect-title-two" href="#">{val.title}</a>
                            </h3>
                            <p>{val.desc}</p>
                        </div>
                    </div>
                ))}
            </div>
        </Fragment>
    )
}

export default FeatureThree
